module.exports = __webpack_public_path__ + "static/media/Concepts_Gardens-Sizes.49f70428.jpg";